import { Component, OnDestroy, OnInit, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import {
  TenderDTO,
  DocumentEnvelopeDTO,
  TenderEnvelopeDTO,
  TenderStateDTO,
  TenderLot,
  TenderLotState,
  getSimpleIdentifierFromString,
  TriStateDTO,
  FileDetailsDTO
} from '../../api/plyca-dtos';
import { UIService } from '../../ui.service';
import { forkJoin, Observable, throwError, of, from, EMPTY } from '../../../../node_modules/rxjs';
import {
  ProcurementProjectDTO,
  EnvelopeDTO,
  ProcurementProjectLotDTO,
  ProcurementProjectLotGroupDTO,
  CompanyDTO
} from '../../api/plyca-dtos-v2';
import { Configuration } from '../../conf/app.constants';
import { TaskHandler } from '../../tasks/TaskHandler';
import * as lodash from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { finalize, catchError, flatMap, combineAll, map, tap, switchMap } from 'rxjs/operators';
import { concat } from 'rxjs';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { Location } from '@angular/common';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PaginationDTO } from '../../api/PaginationModel';
import { MenuItem, SelectItem } from 'primeng-lts/api';

/**
 * Bean de presentación del filtro de ofertas
 */
export class TenderFilter {

  state: Array<TenderStateDTO>;
  lots: Array<ProcurementProjectLotDTO>;
  companies: Array<CompanyDTO>;

  constructor() {
    this.state = [];
    this.lots = [];
    this.companies = [];
  }

}

@Component({
  selector: 'tenderEvaluation',
  templateUrl: 'tenderEvaluation.template.html'
})
export class tenderEvaluationComponent extends TaskHandler
  implements OnInit, OnDestroy {
  loaded = false;

  // INFORMACION DEL EXPEDIENTE
  dossierId: string;
  project: ProcurementProjectDTO;

  public expandedRows: any;
  public panelStatus = [];

  tendersLoaded = false;
  tenderList: Array<TenderDTO>;
  filter: TenderFilter;
  filterLotValues = [];
  companyValues = []
  filteredTenders: Array<TenderDTO>;
  tenderingEnvelopes: Array<EnvelopeDTO>;
  public loadedTenderEnvelopes: Map<string, Array<EnvelopeDTO>>;

  tenderDocs: Array<any> = [];

  envelopeColHeaders: string[];
  lotsColHeaders: string[];

  tenderStates: any[];
  tenderLotStates: any[];
  public yesNoModel: SelectItem[];
  public triStateModel: SelectItem[];

  private editingLots: Map<string, TenderLot>;
  private editingDocs: Map<string, DocumentEnvelopeDTO>;

  tagsParent: string[] = [];
  public groupActions: MenuItem[];

  public initialized = false;
  public hasLots: boolean

  // alias de enumerados para el template
  public TenderStateDTO = TenderStateDTO;
  public TenderLotState = TenderLotState;
  public TriStateDTO = TriStateDTO;

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    protected configuration: Configuration,
    public translationService: TranslateService,
    private headerActionsService: HeaderActionsService,
    private location: Location,
    private elem: ElementRef,
    private helpService: HelpService
  ) {
    super();
    this.lotsColHeaders = ['TenderEvaluation.lots.lot', 'General.state'
      , 'TenderEvaluation.lots.motivationState', 'TenderLotState.abnormal'];
    this.tenderStates = [
      { label: this.translateService.instant('TenderStateDTO.INITIAL'), value: TenderStateDTO.INITIAL },
      // { label: this.translateService.instant('TenderStateDTO.REPAIRING'), value: TenderStateDTO.REPAIRING },
      { label: this.translateService.instant('TenderStateDTO.ACCEPTED'), value: TenderStateDTO.ACCEPTED },
      { label: this.translateService.instant('TenderStateDTO.REJECTED'), value: TenderStateDTO.REJECTED },
      // { label: this.translateService.instant('TenderStateDTO.WITH_AMOUNT'), value: TenderStateDTO.WITH_AMOUNT },
      // { label: this.translateService.instant('TenderStateDTO.WITH_VALUATION'), value: TenderStateDTO.WITH_VALUATION },
      { label: this.translateService.instant('TenderStateDTO.CORRECTED'), value: TenderStateDTO.CORRECTED }
      // { label: this.translateService.instant('TenderStateDTO.CANCELLED'), value: TenderStateDTO.CANCELLED }
    ];
    this.tenderLotStates = [
      { label: this.translateService.instant('TenderLotState.ADMITTED'), value: TenderLotState.ADMITTED },
      { label: this.translateService.instant('TenderLotState.REJECTED'), value: TenderLotState.REJECTED },
      { label: this.translateService.instant('TenderLotState.EXCLUDED'), value: TenderLotState.EXCLUDED }
    ];
    this.triStateModel = [
      { label: this.translateService.instant('General.undefined'), value: TriStateDTO.UNDEFINED },
      { label: this.translateService.instant('General.yes'), value: TriStateDTO.YES },
      { label: this.translateService.instant('General.no'), value: TriStateDTO.NO }
    ];
    this.yesNoModel = [
      { label: this.translateService.instant('General.yes'), value: true },
      { label: this.translateService.instant('General.no'), value: false }
    ];
    this.filter = new TenderFilter();
    this.initEditingInfo();
    this.validaCierreVentana = false;
  }

  ngOnInit(): void {
    this.waitService.startWaiting();
    let idTarea: string = this.task.identifier;
    console.log('Abriendo tarea de valoracion de ofertas: ' + idTarea);
    this.dossierId = this.task.division.project.identifier;
    this.subscribe(forkJoin(
      this.plycaService.getProcurementProject(
        this.dossierId,
        '?expand=expansionSet:subclass_complete'
      ),
      this.plycaService.query<EnvelopeDTO>(
        this.configuration.ENVELOPE_SERVICE_URL,
        {
          procurementProjectId: this.dossierId,
          documentClassType: 'OF',
          expand: 'expansionSet:webclient'
        }
      ),
      this.loadTenders().pipe(
        tap((tenderList: TenderDTO[]) => {
          if (tenderList) {
            tenderList.forEach(tender => this.panelStatus[tender.identifier] = tender.state === TenderStateDTO.REJECTED)
          }
        }),
      )
    ).pipe(finalize(() => {
      this.initialized = true;
      this.waitService.cancelWaiting();
    })),
      results => {
        // respuesta consulta de project
        this.project = results[0];
        // PROCESAR LISTADO DE CRITERIOS
        this.hasLots = this.project.breakdownLot.apportioned;
        this.envelopeColHeaders = [
          'TenderEvaluation.envelopes.name',
          'Envelope.type'
        ];
        if (this.hasLots) {
          this.envelopeColHeaders.push('Envelope.lots');
        }
        // this.lotAwardCriteriaList = new Array<CriteriaDTO>();
        if (this.hasLots) {
          this.project.breakdownLot.lots.forEach(
            (lot: ProcurementProjectLotDTO) => {
              // añadir a combo de filtro
              this.filterLotValues.push({ label: this.getProcurementProjectLotDescription(lot), value: lot });
            }
          );
        }
        // sobres de la oferta
        let docs = [];
        if (results[1] && results[1].content) {
          this.tenderingEnvelopes = results[1].content;
        } else {
          this.tenderingEnvelopes = new Array<EnvelopeDTO>();
        }

        this.tenderingEnvelopes.forEach(envelope => {
          if (envelope.files) {
            envelope.files.forEach(file => {
              let docItem = {};
              docItem['description'] =
                '[' + envelope.description + '] ' + file.description;
              docItem['fileDescription'] = file.description;
              docItem['file'] = file;
              docItem['envelopeDescription'] = envelope.description;
              docItem['envelope'] = envelope;
              docs.push(docItem);
            });
          }
        });

        // respuesta consulta de ofertas
        if (results[2]) {
          this.processTenderList(results[2]);
          let correctedTenders = this.tenderList.find((tender: TenderDTO) => tender.state === TenderStateDTO.CORRECTED);
          if (correctedTenders && this.task) {
            // aviso indicando que existen ofertas marcadas como subsanadas
            this.uiService.showMessage(
              this.translateService.instant('TenderEvaluation.correctedTendersMsg'),
              this.translateService.instant('General.warn'));
          }
          this.expandedRows = this.getExpandedRows();
        } else {
          this.processTenderList([]);
        }
        // PROCESAR LISTADO DE DOCUMENTOS
        docs.forEach(doc => {
          let item = { doc: doc.description, docItem: doc };
          this.tenderList.forEach((tender, idx) => {
            item['tender' + idx] = tender;
          });
          this.tenderDocs.push(item);
        });
        this.filterTenderList();
      });
  }

  private setWindowActions(): void {
    this.headerActionsService.clearActions();
    let initialStateTenderList: TenderDTO[];
    if (this.tenderList) {
      initialStateTenderList = this.tenderList.filter((tender: TenderDTO) => tender.state === TenderStateDTO.INITIAL);
    }
    if (initialStateTenderList && initialStateTenderList.length > 0) {
      // accion aceptar ofertas restantes
      this.subscribe(this.headerActionsService.addAction('TenderEvaluation.acceptTenders'
        , 'fas fa-lg fa-thumbs-up'
        , 'btn-success'
        , true
        , () => this.isNotEditing()),
        (success) => {
          this.uiService.showConfirmMessage({
            message: this.translateService.instant('TenderEvaluation.acceptTendersMsg'),
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              let observableList = initialStateTenderList
                .map((tender: TenderDTO) => of(tender).pipe(
                  flatMap((tenderFromObservable: TenderDTO) => this.patchTenderState(tenderFromObservable,
                    TenderStateDTO.ACCEPTED)),
                  catchError((error: any) => {
                    console.log('Error al aceptar oferta ', tender);
                    return of(tender);
                  })));
              this.waitService.startWaiting();
              this.subscribe(forkJoin(observableList).pipe(finalize(() => this.updateDossierTenders())));
            },
            reject: () => undefined
          });
        });
      this.headerActionsService.addDivider();
    }
    // accion aceptar/despachar
    this.subscribe(this.headerActionsService.addAction('General.accept'
      , 'fa fa-lg fa-check-square'
      , 'btn-primary'
      , true
      , () => this.isNotEditing()),
      success => {
        if (initialStateTenderList && initialStateTenderList.length > 0) {
          const ref = this.uiService.showMessage(this.translateService.instant('TenderEvaluation.pendingTendersMsg'));
          this.subscribe(ref.onClose, result => this.accept());
        } else {
          this.accept();
        }
      });
  }

  public isNotEditing() {
    return this.editingLots.size === 0 && this.editingDocs.size === 0;
  }

  private accept(): void {
    if (this.task) {
      this.processTask();
    } else {
      this.uiService.routeBack();
    }
  }

  public filterTenderList(): void {
    let results = this.tenderList;
    if (this.filter.state.length > 0) {
      results = results
        .filter((tender: TenderDTO) => this.filter.state
          .find((state: TenderStateDTO) => state === tender.state));
    }
    if (this.filter.lots.length > 0) {
      results = results
        .filter((tender: TenderDTO) => this.filter.lots
          .find((lot: ProcurementProjectLotDTO) => this.tenderIncludesLot(tender, lot)));
    }
    if (this.filter.companies.length > 0) {
      results = results
        .filter((tender: TenderDTO) => this.isCompanySelected(tender));
    }
    this.filteredTenders = results.sort((tender1: TenderDTO, tender2: TenderDTO) =>
      this.getCompanyDescription(tender1).localeCompare(this.getCompanyDescription(tender2)));
    // this.initCriteriaTableData();
  }

  private isCompanySelected(tender: TenderDTO): boolean {
    return this.filter.companies.find((company: CompanyDTO) => company?.identifier === tender?.company?.identifier) !== undefined;
  }

  public getCompanyDescription(tender: TenderDTO): string {
    return CompanyDTO.getCompanyDescription(tender.company);
  }

  private tenderIncludesLot(tender: TenderDTO, lot: ProcurementProjectLotDTO): boolean {
    return tender.tendersLots
      && tender.tendersLots
        .find((tenderLot: TenderLot) =>
          getSimpleIdentifierFromString(tenderLot.identifier) === lot.lotId.toString()
        ) !== undefined;
  }

  private envelopeIncludesTenderLot(envelope: EnvelopeDTO, tender: TenderDTO): boolean {
    if (!tender.tenderEnvelopes) {
      return false;
    }

    return (!envelope.lots ||
      envelope.lots.filter((envelopeLot: ProcurementProjectLotDTO) =>
        tender.tendersLots.some(tenderLot =>
          getSimpleIdentifierFromString(tenderLot.identifier) === envelopeLot.lotId.toString())
      ).length > 0
      && (this.filter.lots.length == 0 || envelope.lots.filter((envelopeLot: ProcurementProjectLotDTO) =>
        this.filter.lots.some(filterLot =>
          filterLot.lotId === envelopeLot.lotId)
      ).length > 0)
    )
      && tender.tenderEnvelopes.filter((tenderEnvelope: TenderEnvelopeDTO) =>
        tenderEnvelope.envelope.identifier === envelope.identifier
      ).length > 0;
  }

  private processTenderList(tenders: TenderDTO[]): void {
    this.tenderList = tenders;
    this.companyValues = this.tenderList.map((tender: TenderDTO) => {
      let company = lodash.clone(tender.company)
      company['description'] = this.getCompanyDescription(tender);
      return company;
    }).sort((company1, company2) => company1['description'].localeCompare(company2['description']));
    this.filterTenderList();
    this.loadedTenderEnvelopes = new Map();
    // actualizar map de ofertas y sobres con documentos que usa la pantalla
    this.filteredTenders.forEach((tender: TenderDTO) => {
      let tenderEnvelopes = new Array<EnvelopeDTO>();
      if (this.tenderingEnvelopes) {
        let clonedEnvelope: EnvelopeDTO;
        this.tenderingEnvelopes.forEach((envelope: EnvelopeDTO) => {
          if (this.envelopeIncludesTenderLot(envelope, tender)) {
            clonedEnvelope = lodash.cloneDeep(envelope);
            // anyadir propiedad para expansion de registro en tabla prime
            clonedEnvelope['customIdentifier'] = this.getRowExpansionId(tender, clonedEnvelope);
            tenderEnvelopes.push(clonedEnvelope)
          }
        })
      }
      this.loadedTenderEnvelopes.set(tender.identifier, tenderEnvelopes);
    });
    // acciones pantalla tarea
    this.setWindowActions();
  }

  public isProjectLoaded(): boolean {
    return this.project != null;
  }


  public onPreviousSearchPosition(): void {
    let panel = this.elem.nativeElement.getElementsByClassName(
      'p-table-unfrozen-view'
    );
    if (panel) {
      panel.scrollLeft -= 20;
    }
  }

  public onNextSearchPosition(): void {
    let panel = this.elem.nativeElement.getElementsByClassName(
      'p-table-unfrozen-view'
    );
    if (panel) {
      panel.scrollLeft += 20;
    }
  }

  helpContext() {
    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = storedHelpTags;
          return this.helpService.showContextHelpObservable(HelpType.EDIT_VAL_CRITERIO)
        }
      )));
  }

  public chageDocObservations(observations: string, document: DocumentEnvelopeDTO): void {
    let prevVal = document.observations;
    if (prevVal !== observations) {
      this.uiService.showConfirmMessage({
        message: this.translateService.instant('TenderEvaluation.documents.observationMsg'),
        header: this.translateService.instant('General.warn'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          let objToPatch = new DocumentEnvelopeDTO();
          objToPatch.identifier = document.identifier;
          objToPatch.observations = observations;
          this.subscribe(this.plycaService
            .patch<DocumentEnvelopeDTO>(this.configuration.ENVELOPEDOCUMENT_SERVICE_URL, objToPatch)
            .pipe(
              catchError((e) => {
                document.observations = prevVal;
                return throwError(e);
              })
            ),
            () => {
              this.updateDossierTenders();
            });
        },
        reject: () => {
          document.observations = prevVal;
        }
      });
    }
  }

  public changeDocCorrectedState(
    document: DocumentEnvelopeDTO
  ) {
    let newVal = document.corrected;
    this.uiService.showConfirmMessage({
      message: this.translateService.instant('TenderEvaluation.documents.changeStateMsg'),
      header: this.translateService.instant('General.warn'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let objToPatch = new DocumentEnvelopeDTO();
        objToPatch.identifier = document.identifier;
        objToPatch.corrected = document.corrected;
        this.subscribe(this.plycaService
          .patch<DocumentEnvelopeDTO>(this.configuration.ENVELOPEDOCUMENT_SERVICE_URL, objToPatch)
          .pipe(
            catchError((e) => {
              document.corrected = !newVal;
              return throwError(e);
            })
          ),
          () => {
            this.updateDossierTenders();
          });
      },
      reject: () => {
        document.corrected = !newVal;
      }
    });
  }

  public updateDossierTenders(): void {
    this.waitService.startWaiting();
    // inicializar habilitar botonera mierda
    this.initEditingInfo();
    this.subscribe(this.loadTenders(),
      (result) => {
        if (result) {
          this.processTenderList(result);
        }
      },
      () => undefined,
      () => {
        // acciones pantalla tarea
        this.setWindowActions();
        this.waitService.cancelWaiting();
      }
    );
  }

  private initEditingInfo() {
    this.editingLots = new Map<string, TenderLot>();
    this.editingDocs = new Map<string, DocumentEnvelopeDTO>();
  }

  private loadTenders(): Observable<TenderDTO[]> {
    const url = this.configuration.DOSSIER_SERVICE_URL + this.dossierId + '/tenders';
    return this.plycaService.query<TenderDTO>(url, { expand: 'document,tenderenvelopes.documentEnvelope.fixedFile' }).pipe(
      switchMap((result: PaginationDTO<TenderDTO>) => {
        if (result && result.content) {
          return from(result.content)
        } else {
          of(undefined);
        }
      }),
      map((tender: TenderDTO) => {
        if (tender) {
          //  lot.recklessLow viene a veces a nulo, ponerlos a false para que coincida con el valor del combo
          // if (tender.tendersLots) {
          //   tender.tendersLots.forEach((lot: TenderLot) => {
          //     if (lot && lot.recklessLow === undefined) {
          //       lot.recklessLow = false;
          //     }
          //   });
          // }
          if (tender.electronic) {
            //  document.corrected viene a veces a nulo, ponerlos a false para que coincida con el valor del combo
            if (tender.tenderEnvelopes) {
              tender.tenderEnvelopes.forEach((tenderEnvelope: TenderEnvelopeDTO) => {
                if (tenderEnvelope.documentEnvelope) {
                  tenderEnvelope.documentEnvelope.forEach((document: DocumentEnvelopeDTO) => {
                    if (document && document.corrected === undefined) {
                      document.corrected = false;
                    }
                  })
                }
              })
            };

            return of(tender);
          } else {
            // consultar documentos de ofertas no electonicas
            let params = {
              'expand': 'envelope,file,file.download'
            }
            let url = this.configuration.TENDER_SERVICE_URL + tender.identifier + '/documents';
            return this.plycaService.query<DocumentEnvelopeDTO>(url, params)
              .pipe(
                flatMap((documents: PaginationDTO<DocumentEnvelopeDTO>) => {
                  if (documents && documents.content) {
                    let tenderEnvelopeMap = new Map<string, Array<DocumentEnvelopeDTO>>();
                    documents.content.forEach((document: DocumentEnvelopeDTO) => {
                      //  document.corrected viene a veces a nulo, ponerlos a false para que coincida con el valor del combo
                      if (document && document.corrected === undefined) {
                        document.corrected = false;
                      }
                      let envelopeId = document.envelope.identifier;
                      let envelopeDocuments = tenderEnvelopeMap.get(envelopeId);
                      if (!envelopeDocuments) {
                        envelopeDocuments = new Array<DocumentEnvelopeDTO>();
                        tenderEnvelopeMap.set(envelopeId, envelopeDocuments);
                      }
                      envelopeDocuments.push(document);
                    });
                    // añadir sobres
                    if (tenderEnvelopeMap.size > 0) {
                      tender.tenderEnvelopes = new Array<TenderEnvelopeDTO>();
                      tenderEnvelopeMap.forEach((value: DocumentEnvelopeDTO[], envelopeId: string) => {
                        let tenderEnvelope = new TenderEnvelopeDTO();
                        tenderEnvelope.envelope = value[0].envelope;
                        tenderEnvelope.documentEnvelope = value;
                        tender.tenderEnvelopes.push(tenderEnvelope);
                      })
                    }
                  }
                  return of(tender);
                }
                ),
                catchError((error: any) => {
                  // trazar error
                  console.log(error);
                  // devolver oferta sin documentos
                  return of(tender)
                }));
          }
        } else {
          of(undefined);
        }
      }),
      combineAll()
    )
  }

  viewFile(file: FileDetailsDTO) {
    if (file) {
      this.documentService.viewFile(file);
    }
  }

  downloadEmbedded(file: FileDetailsDTO) {
    if (file) {
      this.documentService.downloadEmbedded(file);
    }
  }

  public getLots(envelope: EnvelopeDTO): string {
    let lots = new Array<any>();
    if (envelope.lots) {
      lots = envelope.lots.sort((lot1, lot2) => lot1.lotNumber - lot2.lotNumber);
      lots = lots.map((lot: ProcurementProjectLotDTO) => this.getProcurementProjectLotDescription(lot))
    }
    let lotGroups = new Array<any>();
    if (envelope.lotGroups) {
      lotGroups = envelope.lotGroups.map((lot: ProcurementProjectLotGroupDTO) => lot.name);
      lotGroups = lotGroups.sort();
    }
    return lots.concat(lotGroups).join(', ');
  }

  /**
   * Devuelve los registros de la tabla de documentos de una oferta
   */
  public getTenderEnvelopeDocuments(
    tender: TenderDTO,
    envelope: EnvelopeDTO
  ): DocumentEnvelopeDTO[] {
    let selectedEnvelope: TenderEnvelopeDTO;
    if (tender.tenderEnvelopes) {
      selectedEnvelope = tender.tenderEnvelopes.find(
        tenderEnvelope =>
          envelope.identifier === tenderEnvelope.envelope.identifier
      );
    }
    if (selectedEnvelope && selectedEnvelope.documentEnvelope) {
      selectedEnvelope.documentEnvelope.forEach(document => {
        document.tender = tender;
        document.tenderEnvelope = selectedEnvelope;
      });
    }
    return selectedEnvelope ? selectedEnvelope.documentEnvelope : undefined;
  }

  public getLotDescription(lot: TenderLot): string {
    const selectedProjectLot = this.project.breakdownLot.lots
      .find((projectLot: ProcurementProjectLotDTO) =>
        projectLot.lotId.toString() === getSimpleIdentifierFromString(lot.identifier)
      );
    return this.getProcurementProjectLotDescription(selectedProjectLot);
  }

  private getProcurementProjectLotDescription(projectLot: ProcurementProjectLotDTO): string {
    return (projectLot) ? projectLot.lotNumber + '-' + projectLot.description : '-';
  }

  public acceptTenderState(tender: TenderDTO): void {
    this.subscribe(this.patchTenderState(tender, TenderStateDTO.ACCEPTED), () => this.updateDossierTenders());
  }

  public rejectTenderState(tender: TenderDTO): void {
    this.subscribe(this.patchTenderState(tender, TenderStateDTO.REJECTED), () => this.updateDossierTenders());
  }

  public changeTenderState(tender: TenderDTO): void {
    if (tender.state === TenderStateDTO.ACCEPTED) {
      this.rejectTenderState(tender);
    } else {
      this.acceptTenderState(tender);
    }
  }

  public lowTender(value: TriStateDTO, tender: TenderDTO): void {
    let tenderLot = new TenderLot();
    tenderLot.identifier = '0';
    tenderLot.recklessLow = value;
    this.lowLotTender(tenderLot, tender);
  }

  private patchTenderState(tender: TenderDTO, state: TenderStateDTO): Observable<any> {
    let patchedTender = new TenderDTO();
    patchedTender.identifier = tender.identifier;
    patchedTender.state = state
    return this.plycaService.patch<TenderDTO>(
      this.configuration.TENDER_SERVICE_URL,
      patchedTender
    );
  }

  public lowLotTender(lot: TenderLot, tender: TenderDTO): void {
    let patchedTenderLot = new TenderLot();
    patchedTenderLot.identifier = lot.identifier + '<>' + tender.identifier;
    patchedTenderLot.recklessLow = lot.recklessLow;
    patchedTenderLot.motivationState = lot.motivationState;
    let url = this.configuration.TENDERLOT_SERVICE_URL.replace('{tenderIdentifier}', tender.identifier);
    this.subscribe(this.plycaService.patch<TenderLot>(
      url,
      patchedTenderLot
    ), () => this.updateDossierTenders());
  }

  public hasCorrectedDocumensts(tender: TenderDTO, envelope: EnvelopeDTO): boolean {
    let documents = this.getTenderEnvelopeDocuments(tender, envelope);
    return documents && documents.find((file: DocumentEnvelopeDTO) => file.corrected) !== undefined;
  }

  /**
   * Metodos de edicion de lotes
   */
  public onLotEditInit(lot: TenderLot): void {
    let editedLot = lodash.cloneDeep(lot);
    this.editingLots.set(editedLot.identifier, editedLot);
  }
  public onLotEditSave(lot: TenderLot, tender: TenderDTO): void {
    let previousLotData = this.editingLots.get(lot.identifier)
    if (previousLotData) {
      const patchTenderLot = previousLotData.state !== lot.state ||
        previousLotData.recklessLow !== lot.recklessLow ||
        previousLotData.motivationState !== lot.motivationState;
      if (patchTenderLot) {
        if ((lot.state === TenderLotState.REJECTED || lot.recklessLow === TriStateDTO.YES) && !lot.motivationState) {
          this.uiService.showMessage(this.translateService.instant('TenderList.errors.reasonEmpty'));
        } else {
          this.editingLots.delete(lot.identifier);
          this.patchTenderLot(lot, tender);
          return;
        }
      }
      this.onLotEditCancel(lot);
    }
  }
  public onLotEditCancel(lot: TenderLot): void {
    let previousLotData = this.editingLots.get(lot.identifier)
    lodash.assign(lot, previousLotData);
    this.editingLots.delete(lot.identifier);
  }

  private patchTenderLot(tenderLot: TenderLot, tender: TenderDTO): void {
    this.waitService.startWaiting();
    this.subscribe(this.patchTenderLotObs(tenderLot, tender).pipe(
      finalize(() => this.updateDossierTenders())
    ));
  }

  private patchTenderLotObs(tenderLot: TenderLot, tender: TenderDTO): Observable<TenderLot> {
    this.waitService.startWaiting();
    const patchedTenderLot = new TenderLot();
    patchedTenderLot.identifier = tenderLot.identifier;
    patchedTenderLot.state = tenderLot.state;
    patchedTenderLot.motivationState = tenderLot.motivationState;
    patchedTenderLot.recklessLow = tenderLot.recklessLow;
    let url = this.configuration.TENDERLOT_SERVICE_URL.replace('{tenderIdentifier}', tender.identifier);
    return this.plycaService.patch<TenderLot>(url, patchedTenderLot);
  }

  /**
     * Metodos de edicion de documentos
     */
  public onDocEditInit(document: DocumentEnvelopeDTO): void {
    let editedDocument = lodash.cloneDeep(document);
    this.editingDocs.set(editedDocument.identifier, editedDocument);
  }
  public onDocEditSave(document: DocumentEnvelopeDTO): void {
    let previousDocument = this.editingDocs.get(document.identifier)
    if (previousDocument) {
      const patchDocument = document.identifier !== previousDocument.identifier ||
        document.observations !== previousDocument.observations ||
        document.corrected !== previousDocument.corrected;
      if (patchDocument) {
        this.editingDocs.delete(document.identifier);
        this.patchDocument(document);
      } else {
        this.onDocEditCancel(document);
      }
    }
  }

  public onDocEditCancel(document: DocumentEnvelopeDTO): void {
    let previousDocument = this.editingDocs.get(document.identifier)
    lodash.assign(document, previousDocument);
    this.editingDocs.delete(document.identifier);
  }

  private patchDocument(document: DocumentEnvelopeDTO): void {
    this.waitService.startWaiting();
    let objToPatch = new DocumentEnvelopeDTO();
    objToPatch.identifier = document.identifier;
    objToPatch.observations = document.observations;
    objToPatch.corrected = document.corrected;
    this.subscribe(this.plycaService
      .patch<DocumentEnvelopeDTO>(this.configuration.ENVELOPEDOCUMENT_SERVICE_URL, objToPatch)
      .pipe(
        finalize(() => this.updateDossierTenders())
      ));
  }

  public getVisibleLots(): Array<ProcurementProjectLotDTO> {
    let lots: Array<ProcurementProjectLotDTO>;
    if (this.hasLots) {
      lots = this.project.breakdownLot.lots.filter((lot: ProcurementProjectLotDTO) =>
        this.filter.lots.length === 0 ||
        this.filter.lots.find((visibleLot: ProcurementProjectLotDTO) => visibleLot.lotNumber === lot.lotNumber)
      );
    } else {
      lots = [];
      lots.push(this.project.breakdownLot.totalLots);
    }
    return lots.sort((lot1: ProcurementProjectLotDTO, lot2: ProcurementProjectLotDTO) => lot1.lotNumber - lot2.lotNumber);
  }

  /**
   * Inicializa identificadores de tabla para expandir (documentos de las ofertas)
   */
  private getExpandedRows() {
    let expandedRow: any;
    expandedRow = {};
    if (this.tenderList) {
      this.tenderList
        .filter((tender: TenderDTO) => tender.tenderEnvelopes)
        .forEach((tender: TenderDTO) => {
          tender.tenderEnvelopes
            .filter((tenderEnvelope: TenderEnvelopeDTO) => tenderEnvelope.documentEnvelope
              && tenderEnvelope.documentEnvelope.length > 0)
            .forEach((tenderEnvelope: TenderEnvelopeDTO) => {
              expandedRow[this.getRowExpansionId(tender, tenderEnvelope.envelope)] = tenderEnvelope.documentEnvelope
                // tslint:disable-next-line:triple-equals
                .some((documentEnvelope: DocumentEnvelopeDTO) => documentEnvelope.file != undefined);
            });
        });
    }
    return expandedRow;
  }

  private getRowExpansionId(tender: TenderDTO, envelope: EnvelopeDTO): string {
    return tender.identifier + '<>' + envelope.identifier;
  }

  public togglePanel(identifier: string, toggleEvent: any): void {
    this.panelStatus[identifier] = toggleEvent.collapsed;
  }

  public loadGroupActions(tender: TenderDTO): void {
    this.groupActions = [
      {
        label: this.translateService.instant('TendeDocuments.Lots.Accept'),
        icon: 'far fa-thumbs-up text-success',
        command: () => this.acceptAllLots(tender)
      },
      {
        label: this.translateService.instant('TendeDocuments.Lots.Reject'),
        icon: 'far fa-thumbs-down text-danger',
        command: () => this.rejectAllLots(tender)
      },
      {
        label: this.translateService.instant('TendeDocuments.Lots.Exclude'),
        icon: 'far fa-thumbs-down text-danger',
        command: () => this.excludeAllLots(tender)
      }
    ];
  }

  private excludeAllLots(tender: TenderDTO): void {
    return this.patchStateAllLots(tender, TenderLotState.EXCLUDED);
  }

  private acceptAllLots(tender: TenderDTO): void {
    return this.patchStateAllLots(tender, TenderLotState.ADMITTED);
  }

  private rejectAllLots(tender: TenderDTO): void {
    return this.patchStateAllLots(tender, TenderLotState.REJECTED);
  }


  private patchStateAllLots(tender: TenderDTO, newstate: TenderLotState): void {
    const requestObs = new Array<Observable<any>>();
    if (tender.tendersLots?.length > 0) {
      const errorLots = new Array<string>();
      this.getInitialLots(tender).forEach((lot: TenderLot) => {
        const clonedLot = lodash.clone(lot);
        clonedLot.state = newstate
        // cambio el estado a una copia por no modificar
        const internalObs = this.patchTenderLotObs(clonedLot, tender).pipe(
          catchError((error: any) => {
            console.error('Error al aceptar/rechazar lote ' + clonedLot.identifier, error);
            errorLots.push(lot.identifier);
            return of({});
          })
        );
        requestObs.push(internalObs);
      });
      this.waitService.startWaiting();
      this.subscribe(concat(...requestObs).pipe(
        finalize(() => {
          if (errorLots.length > 0) {
            this.uiService.showMessage(
              'Se produjo un error al aceptar los lotes con identificador: ' + errorLots.join(', ')
              , this.translationService.instant('General.error'));
          } else {
            // actualizar expediente
            this.updateDossierTenders();
          }
        })
      ));
    }
  }

  public hasInitialStateLots(tender: TenderDTO): boolean {
    return this.getInitialLots(tender)?.length > 0;
  }

  private getInitialLots(tender: TenderDTO): Array<TenderLot> {
    return (tender.tendersLots) ? tender.tendersLots.filter((lot: TenderLot) => lot?.state === TenderLotState.INITIAL)
      : [];
  }

}
